<template>
    <router-view />
    <vue3-snackbar bottom left :duration="5000"> </vue3-snackbar>
    <modals-container></modals-container>
</template>

<script>
import { onBeforeMount, watch } from 'vue';
import { useRouter } from 'vue-router';
import { ModalsContainer } from 'vue-final-modal';
import useParameters from '@/services/useParameters';
import { useStore } from 'vuex';

import 'vue-final-modal/dist/style.css';

export default {
    name: 'DarminPlus',
    components: { ModalsContainer },
    setup() {
        const { getParameters } = useParameters();
        const router = useRouter();
        const store = useStore();

        onBeforeMount(getParameters);

        watch(
            () => router.currentRoute.value.query.content,
            (contentHash) => {
                if (contentHash) {
                    store.commit('Auth/setContentHash', contentHash);
                }
            },
            { immediate: true }
        );
        return {};
    },
};
</script>
